export * from "./CustomerInfo";
export { default } from "./CustomerInfo";
